/*
 * @Author: liang yuhong
 * @Date:   2018-08-22 09:34:57
 * @Last Modified by:   Ding Jianlong
 * @Last Modified time: 2018-09-17 10:43:18
 */
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    roomDetailShow: false,
    meetDetailShow: false,
    selectedDay: moment().format('YYYY-MM-DD'),
    occupy: [],
    userInfo: {},
    isPc: false
  },
  mutations: {
    roomDetailTag(state, data) {
      state.roomDetailShow = data
    },
    meetDetailTag(state, data) {
      state.meetDetailShow = data
    },
    setSelectedDay(state, data) {
      state.selectedDay = data
      console.log('设置', data)
    },
    setOccupy(state, data) {
      if (data) {
        state.occupy = data.split(',')
      } else {
        state.occupy = []
      }
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setPc(state, data) {
      state.isPc = data
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js